import clsx from 'clsx';
import { HTMLAttributes } from 'react';

export type BadgeProps = {
  variant?: 'neutral' | 'success' | 'danger' | 'warning' | 'primary';
  children: React.ReactNode;
} & HTMLAttributes<HTMLSpanElement>;

export function Badge({
  variant = 'neutral',
  className,
  children,
  ...props
}: BadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        variant === 'neutral' && 'bg-gray-100 text-gray-700',
        variant === 'success' && 'bg-emerald-100 text-emerald-800',
        variant === 'danger' && 'bg-red-100 text-red-700',
        variant === 'warning' && 'bg-amber-100 text-amber-900',
        variant === 'primary' && 'bg-primary/15 text-primary',
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}
